
























  import { Component, Vue, Prop } from 'vue-property-decorator'
  import { MappedAttributeMultiCheckboxFilter } from '@one/types'
  import { MultiCheckboxFilterChangeEvent } from '~/utils/ProductsListing'

  @Component({
    components: {
      FilterLabel: () => import('~/components/atoms/labels/FilterLabel.vue'),
      OneMulticheckboxFilterItem: () =>
        import('../../atoms/multicheckboxes/OneMulticheckboxFilterItem.vue'),
    },
  })
  export default class OneMultiCheckboxFilter extends Vue {
    name: string = 'one-multicheckbox-filter'

    @Prop({
      required: true,
      type: Object,
    })
    filter!: MappedAttributeMultiCheckboxFilter

    @Prop({
      required: true,
      type: String,
    })
    testId!: string

    isCollapsed: boolean = true

    get items(): Array<string> {
      return Object.values(this.filter.items)
        .filter(item => {
          return item.count > 0
        })
        .sort((a, b) => a.itemOrder! - b.itemOrder!)

        .map(item => item.valueCode)
    }

    get hasItemsToShow(): boolean {
      return this.items.length > 0
    }

    get filterUnit(): string | null {
      return this.filter.unit ? `[${this.filter.unit}]` : null
    }

    isDisabled(filterValueCode: string) {
      return this.filter.items[filterValueCode].count < 1
    }

    getValueText(filterValueCode: string): string {
      return `${this.filter.items[filterValueCode].label} (${this.filter.items[filterValueCode].count})`
    }

    getValueIcon(filterValueCode: string): string | undefined {
      return this.filter.items[filterValueCode]?.icon
    }

    isValueSelected(filterValueCode: string): boolean {
      return this.filter.items[filterValueCode].selected
    }

    filterValueChanged(filterValueCode: string, isSelected: boolean) {
      this.$emit('input', {
        filterValue: filterValueCode,
        isSelected: isSelected,
      } as MultiCheckboxFilterChangeEvent)
    }

    onCollapseToggle() {
      this.isCollapsed = !this.isCollapsed
      this.$emit('isCollapsed', this.isCollapsed)
    }

    mounted() {
      if (this.filter.expanded) this.onCollapseToggle()
    }
  }
